/* Mosaicci — ortak sepete ekleme. form[data-ms-add-form] gönderimlerini yakalar.
   Sunucu yanıtı esas alınır; belirsiz ağ hatasında otomatik tekrar YOK. */
(function () {
  if (window.MosaicciCart) return;
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function setCount(n) {
    document.querySelectorAll('[data-mm-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function msg(form, text, kind, withCart) {
    var s = form.querySelector('[data-ms-status]');
    if (!s) return;
    s.hidden = false;
    s.setAttribute('data-kind', kind);
    s.replaceChildren(document.createTextNode(text));
    if (withCart) {
      var a = document.createElement('a');
      a.href = base + 'cart';
      a.textContent = 'Sepete git';
      s.append(' ', a);
    }
  }
  function add(form) {
    if (form.dataset.busy) return Promise.resolve();
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) { msg(form, 'Lütfen geçerli bir seçenek seçin.', 'error'); return Promise.resolve(); }
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    form.dataset.busy = '1';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Ekleniyor…'; }
    var s = form.querySelector('[data-ms-status]'); if (s) s.hidden = true;

    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          msg(form, res.j.description || res.j.message || 'Ürün sepete eklenemedi. Seçiminizi kontrol edip tekrar deneyin.', 'error');
          return;
        }
        msg(form, 'Sepete eklendi.', 'ok', true);
        document.dispatchEvent(new CustomEvent('mosaicci:cart:added', { detail: res.j }));
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () {});
      })
      .catch(function () {
        // Belirsiz sonuç: körlemesine tekrar yerine sepeti sorgula
        var vid = +idEl.value;
        return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            setCount(c.item_count);
            var has = (c.items || []).some(function (it) { return it.variant_id === vid; });
            if (has) msg(form, 'Bağlantı kesildi ama ürün sepetinizde görünüyor. Tekrar eklemeden önce sepeti kontrol edin.', 'warn', true);
            else msg(form, 'Bağlantı kesildi; ürün sepete eklenmedi. Tekrar deneyebilirsiniz.', 'error');
          })
          .catch(function () {
            msg(form, 'Bağlantı kesildi; ürün eklenmiş olabilir. Tekrar eklemeden önce sepeti kontrol edin.', 'warn', true);
          });
      })
      .finally(function () {
        delete form.dataset.busy;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; }
        document.dispatchEvent(new CustomEvent('mosaicci:cart:settled', { detail: { form: form } }));
      });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-ms-add-form]');
    if (!f) return;
    e.preventDefault();
    add(f);
  });
  window.MosaicciCart = { add: add };
})();
